import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MainURL from '../../MainURL';
import Header from '../../components/Header';
import { CONSOLE_DENIED_MESSAGE, saveSundaySchoolSession, staffRoleOf } from '../sundaySchoolSession';
import { syncSelectedDepartment } from '../SundaySchoolLayout';
import '../SundaySchoolConsole.scss';

export default function SundaySchoolLogin() {
  const [account, setAccount] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${MainURL}/sundayschool/login`, {
        email: account,
        password,
      });
      if (!data.ok) {
        setError(data.message || '로그인에 실패했습니다.');
        return;
      }
      // 부서담당자·스텝 이상만(교사·학부모는 주일학교 앱).
      if (data.user.role !== 'teacher' || staffRoleOf({ user: data.user, church: data.church }) === '교사') {
        setError(CONSOLE_DENIED_MESSAGE);
        return;
      }
      saveSundaySchoolSession({ user: data.user, church: data.church });
      // 첫 화면부터 부서 기준으로 조회하도록 들어가기 전에 부서를 정해 둔다.
      await syncSelectedDepartment().catch((err) => console.error('GET /sundayschool/church/departments', err));
      navigate('/manage-ss/dashboard');
    } catch (err) {
      console.error('POST /sundayschool/login', err);
      setError('서버에 연결할 수 없습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sundayschool-console">
      <Header />
      <div className="auth login-page">
        <div className="auth-card">
          <div className="auth-logo">
            <span className="mark">🛠️</span> 주일학교 관리자 콘솔
          </div>
          <p className="center muted login-subtitle">주일학교 운영 전체를 한 곳에서 관리하세요</p>

          <form onSubmit={onSubmit}>
            <div className="field">
              <label>관리자 계정</label>
              <input
                className="input"
                type="email"
                value={account}
                onChange={(e) => setAccount(e.target.value)}
              />
            </div>
            <div className="field">
              <label>비밀번호</label>
              <input
                className="input"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {error && (
              <div className="mt8 fine-print" style={{ color: 'var(--danger, #e5484d)' }}>
                {error}
              </div>
            )}
            <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
              {loading ? '로그인 중...' : '관리자로 로그인'}
            </button>
          </form>
          <div className="center mt16 fine-print muted">
            교회 등록 때 만든 교회 관리자 계정, 또는 교사·운영자 계정으로 접근할 수 있어요
          </div>
        </div>
      </div>
    </div>
  );
}
